module.exports = __webpack_public_path__ + "static/transport-management-system-171727aee726934ebca387ccf3591c77.jpg";